import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ReactQueryDevtools } from 'react-query-devtools';
import { SnackbarProvider } from 'notistack';
import Button from '@material-ui/core/Button'

import Notification from './utils/notification'
import Routes from './routes';

import './assets/css/main.css';
import './assets/css/layout.css';

function App() {
  AOS.init();
  return (
    <>
      <ReactQueryDevtools initialIsOpen />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        ref={Notification.reference}
        action={() => <Button onClick={Notification.close}>dismiss</Button>}
      >
        <Routes />
      </SnackbarProvider>
    </>
  );
}

export default App;
